import React from "react";

import { Brand } from "@/custom-types/Wordpress";

import Card from "@/components/botanic/Card";

import BylineImage from "../BylineImage";

type Props = { image?: string; name: string; url: string };

const BrandBoxContent: React.FC<Props> = ({ image, name, url }) => {
  return (
    <div className="flex items-center">
      {image && image !== "" && (
        <BylineImage
          src={image}
          alt={name}
          size="large"
          className="flex-shrink-0"
        />
      )}
      <div className="inline-block align-middle leading-none">
        <span className="block">
          <i className="text-xs">Presented By</i>
          <a
            className="underline block font-bold"
            href={url}
            rel="sponsored"
            title="Link For Brand Name"
          >
            {name}
          </a>
        </span>
      </div>
    </div>
  );
};

export default ({ brand }: { brand: Brand }) => {
  const { name, url, image, customImage } = brand;
  const validImage = image || customImage || "";

  return name && url ? (
    <Card className="border border-light-grey p-lg">
      <BrandBoxContent image={validImage} name={name} url={url} />
    </Card>
  ) : (
    <></>
  );
};
